import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { STUDENT_EXPORT_LIMIT } from "../../../../src/app/constants";

import * as _ from "lodash";

@Component({
  selector: "app-export-students-to-csv-modal",
  templateUrl: "./export-students-to-csv-modal.component.html",
  styleUrls: ["./export-students-to-csv-modal.component.scss"],
})
export class ExportStudentsToCsvModalComponent {
  error: string;
  STUDENT_EXPORT_LIMIT: number = STUDENT_EXPORT_LIMIT;
  isOverLimit: boolean

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ExportStudentsToCsvModalComponent>,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.isOverLimit = this.data.studentCount >= STUDENT_EXPORT_LIMIT;
  }

  closeModal() {
    this.dialogRef.close();
  }

  exportToCSV() {
    this.error = null;
    this.dialogRef.close({ action: "export" });
  }
}
